import { render, staticRenderFns } from "./newmeetingpc.vue?vue&type=template&id=67af17ef&scoped=true"
import script from "./newmeetingpc.vue?vue&type=script&lang=js"
export * from "./newmeetingpc.vue?vue&type=script&lang=js"
import style0 from "./newmeetingpc.vue?vue&type=style&index=0&id=67af17ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67af17ef",
  null
  
)

export default component.exports